import React from 'react'
import * as S from './styled'
import { MapBullet } from '~/components/molecules/Maps/MapBullets'
import { MapAndBullets } from '~/components/molecules/Maps/MapAndBullets'
import { getBustTheCacheImageSrc } from '~/utils/images'

const BULLETS: MapBullet[] = [
  {
    color: 'yellow',
    text: 'We operate as Custodia Bank, Inc. in the following states and territories: AL, AZ, CA, CO, DC, FL, ID, KS, MA, MO, NH, SC, WY',
  },
  {
    color: 'blue',
    text: 'We operate as Custodia Digital Services in the following states: AK, GA, MD, MN, MS, MT, ND, NE, PA, RI, SD, TX, UT, VT (non-money transmission services only), WA, WI, WV',
  },
  {
    color: 'gray',
    text: 'Custodia is not currently operating in these states',
  },
]

export const DbaHeader = () => (
  <S.HeaderTextWrapper>
    <h1>Operating Information</h1>
    <h2>
      Custodia Bank, Inc. operates as Custodia Digital
      <br />
      Services in certain US states.
    </h2>
  </S.HeaderTextWrapper>
)

export const DbaMap = () => (
  <MapAndBullets
    bullets={BULLETS}
    mapSrc={getBustTheCacheImageSrc(`/images/maps/dba_map.png`)}
  />
)
